"use client";

// useSignedIn — "is someone signed in here?", asked in the browser.
//
// A public page (a skill, a guide) only needs this to choose where one button
// points. Asking on the server meant reading cookies, and reading cookies
// forced the whole page to render per request: every crawler hit on the skills
// commons ran a function and a Supabase round-trip to learn "nobody"
// (2026-09-30). Asked here instead, the page is cached once and the answer
// arrives a beat after mount. getSession() reads the local cookie — no network.

import { useEffect, useState } from "react";
import { createClient } from "./client";

export function useSignedIn(): boolean {
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    let live = true;
    (async () => {
      try {
        const { data } = await createClient().auth.getSession();
        if (live) setSignedIn(!!data.session);
      } catch {
        /* no auth env here — a public read stays a public read */
      }
    })();
    return () => { live = false; };
  }, []);
  return signedIn;
}
